var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8832 6.16179L23.7456 1.43535C23.0751 0.855926 22.1965 0.523459 21.2769 0.501195C20.3572 0.478931 19.4608 0.768424 18.7581 1.31461L1.8829 16.8394C1.27683 17.4017 0.899461 18.1387 0.814139 18.9266L0.00788062 26.1198C-0.0173779 26.3724 0.0182576 26.6271 0.112247 26.8657C0.206235 27.1042 0.356263 27.3207 0.551637 27.4998C0.726839 27.6596 0.934621 27.7861 1.16307 27.872C1.39152 27.9578 1.63614 28.0013 1.8829 28H2.05165L9.87049 27.3445C10.727 27.266 11.5281 26.9189 12.1393 26.3613L29.0145 10.8365C29.6694 10.1999 30.0234 9.35043 29.9988 8.47419C29.9742 7.59795 29.573 6.76641 28.8832 6.16179ZM9.53299 23.8946L3.90792 24.3776L4.41418 19.2026L15.008 9.57725L20.0706 14.2347L9.53299 23.8946ZM22.5081 11.9232L17.4831 7.30028L21.1394 3.85032L26.2582 8.55951L22.5081 11.9232Z",
    fill: "#DB0716"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.4f86a029070ecd4bb81967e230e1fc11.svg";
export { ForwardRef as ReactComponent };